import { FETCH_WORKOUT_CATS } from '../actionTypes';

const initialState = {};

export default function(state = initialState, action=null){
  if (action.type === FETCH_WORKOUT_CATS) {
      return {...action.payload};
  } else {
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/workoutCats.js